import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-text-center p-mb-6 p-mt-3 p-p-3 jumbotron" }
const _hoisted_2 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-mx-auto p-mb-6 p-mt-6 geocoder-container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "geocoder" })
], -1)
const _hoisted_6 = { class: "p-mx-auto" }
const _hoisted_7 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "p-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_progress_spinner = _resolveComponent("progress-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.labels.COVERAGE_TITLE), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.labels.COVERAGE_SUB_TITLE), 1)
    ]),
    (_ctx.coverageCheckResult.value?.in_coverage !== false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.labels.COVERAGE_RELOCATION_FEE), 1))
      : _createCommentVNode("", true),
    (_ctx.coverageCheckResult.value?.in_coverage === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode("  "),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_ctx.coverageCheckResult.value?.in_coverage === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.labels.COVERAGE_NO_LINE_1), 1),
            _hoisted_8,
            _createElementVNode("p", {
              innerHTML: _ctx.labels.COVERAGE_NO_LINE_2
            }, null, 8, _hoisted_9),
            _createVNode(_component_Button, {
              class: "p-d-block p-mx-auto p-mt-6",
              label: _ctx.labels.COVERAGE_BUTTON_NEXT,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextPage()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.coverageCheckResult.error === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", null, _toDisplayString(_ctx.labels.COVERAGE_ERROR_LINE_1), 1),
            _hoisted_11,
            _createElementVNode("p", {
              innerHTML: _ctx.labels.COVERAGE_ERROR_LINE_2
            }, null, 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_progress_spinner, { class: "p-mx-auto" })
        ]))
      : _createCommentVNode("", true)
  ]))
}